import React, { useState } from "react";
import { Format, ListBuilder } from "@redriver/cinnamon";
import { ContentPanel } from "components/displays";
import { SortableTable } from "features/../../../shared/components/tables/sortableTable";
import { getClientChangeRequests } from "features/Companies/Customers/Change Requests/actions";
import { Icon } from "semantic-ui-react";
import { ActionsMenu } from "features/Companies/Customers/Change Requests/index";
import { ClientInfoReviewState } from "features/../../../shared/constants/enums/ClientInfoReviewState";

const ChangeRequests = ({ clientId }) => {
  const [lastUpdated, setLastUpdated] = useState(Date.now);
  const columns = [
    { field: "submittedByName", title: "Submitted By", sortable: false },
    {
      field: "submittedTime",
      title: "Submitted Time",
      render: (item) => (
        <Format.Date value={item.submittedTime} format="HH:mm DD MMM YYYY" />
      ),
      sortable: false,
    },
    {
      field: "reviewedTime",
      title: "Time Reviewed",
      render: (item) =>
        (item.reviewState === ClientInfoReviewState.Approved ||
          item.reviewState === ClientInfoReviewState.Rejected) && (
          <Format.Date value={item.reviewedTime} format="HH:mm DD MMM YYYY" />
        ),
      sortable: false,
    },
    {
      field: "reviewedByName",
      title: "Reviewed By",
      sortable: false,
    },
    {
      field: "reviewState",
      title: "Review State",
      render: (item) =>
        item.reviewState === ClientInfoReviewState.Approved ? (
          <Icon name="check" color="green" />
        ) : item.reviewState === ClientInfoReviewState.Pending ? (
          <Icon name="clock" color="orange" />
        ) : (
          <Icon name="close" color="red" />
        ),
      sortable: false,
    },
    {
      field: "",
      title: "",
      render: (item) => (
        <ActionsMenu
          onSubmitted={() => setLastUpdated(Date.now)}
          reviewState={item.reviewState}
          requestId={item.id}
          clientId={clientId}
        />
      ),
      width: "5%",
      sortable: false,
    },
  ];

  return (
    <ListBuilder
      withTable
      loadAction={getClientChangeRequests}
      loadParams={{ clientId, lastUpdated }}
      loadTransform={(data) => data.results}
      renderList={(tableProps, state, events) => (
        <ContentPanel
          title="Change Requests"
          wrapperCssClass="outline-grid products-list"
          headerCssClass="defaults-page-title"
        >
          <div className="companies-products">
            <div className="vertical-scrollbar-requests">
              <SortableTable
                state={state}
                events={events}
                tableProps={tableProps}
                emptyMessage="No requests found"
                columns={columns}
              />
            </div>
          </div>
        </ContentPanel>
      )}
    />
  );
};

export default ChangeRequests;
